/**
 * Legt een gevoelige actie vast in audit_log: wie heeft wát gedaan, en wanneer.
 *
 * De tabel bestond al in het schema, met RLS klaar (iedereen schrijft zijn
 * eigen regel, alleen de admin leest ze terug), maar werd nergens gebruikt.
 * Niet elke schrijfactie hoeft hier te staan — alleen de acties die met geld
 * of contactgegevens te maken hebben, waar achteraf moet kunnen worden
 * nagegaan wie op de knop heeft gedrukt.
 *
 * Faalt het wegschrijven zelf, dan blokkeert dat de eigenlijke actie niet:
 * een logregel die niet lukt mag nooit een echte handeling laten mislukken.
 */

import type { Json } from '@qc/db';
import { supabase } from './supabase.js';

export async function logAudit(
  handeling: string,
  tabel: string,
  recordId: string,
  details: Record<string, Json>,
): Promise<void> {
  try {
    const { data } = await supabase.auth.getUser();
    const { error } = await supabase.from('audit_log').insert({
      gebruiker_id: data.user?.id ?? null,
      handeling,
      tabel,
      record_id: recordId,
      details,
    });
    if (error) console.error('Audit-log wegschrijven mislukt', error);
  } catch (oorzaak) {
    console.error('Audit-log wegschrijven mislukt', oorzaak);
  }
}
